$ = require 'jquery'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
_ = require 'underscore'

module.exports = class extends React.Component
  displayName: "Wrapper"

  UNSAFE_componentWillMount: ->
    # Trigger a data load
    @props.view.getData?()

  componentDidMount: ->

    node = ReactDOM.findDOMNode(this)

    el = @props.view.render().el

    $(node).append(el)

  render: ->
    if this.props.onClick
      passedProps = _.assign(_.pick(@props, ['className']), { onClick: this.props.onClick })
    else
      passedProps = _.pick(@props, ['className'])

    return React.createElement 'div', passedProps
